import { atom } from 'jotai';

export const learningAtom = atom<number>(0);
export const completionAtom = atom<number>(0);
export const examTestAtom = atom<number>(0);
export const surveyAtom = atom<number>(0);
export const isFetchCountData = atom<boolean>(false);
